import { useMutation, useQueryClient } from 'react-query'
import { useParams } from 'react-router-dom'
import { QUERY_KEYS } from 'src/constants'

import { paymentsService } from 'src/services/payments.service'
import { IAccountByIdRespDto } from 'src/types'

const useCancelSubscription = () => {
  const { accountId } = useParams()
  const queryClient = useQueryClient()

  return useMutation(() => paymentsService.cancelSubscription({ accountId: accountId! }), {
    onSuccess: (data) => {
      if (!data) return

      queryClient.setQueriesData(
        [QUERY_KEYS.ACCOUNT, accountId],
        (prev: IAccountByIdRespDto | undefined): IAccountByIdRespDto => {
          if (!prev) return prev as any

          return {
            ...prev,
            subscription_cancelled: true,
          }
        },
      )
    },
  })
}

export { useCancelSubscription }
